
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(323|591|977)|(410|571|997)2|1096|1528|2646|4294|5513|6491|8135|8279)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
